import { apiServer } from "../config";
import { AddPhotoImageData } from "../types";
import { fetchWithToken } from "./fetchWithToken";

export async function postFeedbackDesktop(
  token: string,
  notes: string,
  images: AddPhotoImageData[]
) {
  try {
    const formData = new FormData();
    formData.append("notes", notes);
    formData.append("image", images.length.toString());
    for (let i = 0; i < images.length; i++) {
      const imageUri = images[i].imageUrl;
      const fileName = `image${i}.jpg`;

      // Convert the base64 image to a Blob
      const response = await fetch(imageUri);
      const blob = await response.blob();

      formData.append(`image${i}`, blob, fileName);
    }

    const response = await fetchWithToken(`${apiServer}/basic-page/feedback-ticket-submit`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    const data = await response.json();

    if (data.status === "error") {
      console.log(data);
      return data.message;
    } else {
      return data;
    }
  } catch (error: any) {
    console.log(error);
    return error.message;
  }
}


export interface FeedbackTicketData {
  notes: string;
  data: { name: string }[];
  token: string;
}

export async function postFeedback(props: FeedbackTicketData) {
  const { notes, data, token } = props;

  const formData = new FormData();
  formData.append("notes", notes);

  for (let i = 0; i < data.length; i++) {
    const imageUri = data[i].name; // Assuming you want to send the first image
    const fileName = `image${i}.jpg`; // Adjust accordingly

    const file = {
      uri: imageUri,
      type: "image/jpeg",
      name: fileName,
    };
    formData.append(`image${i}`, file as any, fileName);
  }

  const response = await fetchWithToken(
    apiServer + "/basic-page/feedback-ticket-submit",
    {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    }
  );

  const responseData = await response.json();
  if (responseData.status === "error") {
    throw new Error(responseData.errors.notes[0]);
  }
  // if (responseData.data.feedback && responseData.data.feedback === 'saved') {
  //   showAlert(responseData.message, 'Success');
  // }
  return responseData;
}
